import { createContext, useContext, useEffect, useState } from "react";

const CrumbContext = createContext({ crumbs: [], setCrumbs: () => {} });

export function CrumbProvider({ children }) {
  const [crumbs, setCrumbs] = useState([]);
  return <CrumbContext.Provider value={{ crumbs, setCrumbs }}>{children}</CrumbContext.Provider>;
}

export const useCrumbState = () => useContext(CrumbContext).crumbs;

// Pages call useCrumbs([{label, to}, ...]) to set the breadcrumb trail after "Ana Sayfa".
export function useCrumbs(crumbs) {
  const { setCrumbs } = useContext(CrumbContext);
  const key = JSON.stringify(crumbs);
  useEffect(() => { setCrumbs(JSON.parse(key)); }, [key, setCrumbs]);
}
